export const MOCK_TRANSACTIONS = [
  {
    transactionId: "TXN-A1B2C3D4",
    userId: 1,
    userFullName: "John Doe",
    userEmail: "john.doe@example.edu",
    amount: 50.0,
    currency: "TRY",
    transactionType: "EVENT_TICKET",
    relatedEntityId: "101",
    eventId: 1,
    clubId: null,
    status: "COMPLETED",
    paymentMethod: "MANUAL_TRANSFER",
    referenceCode: "REF-12345",
    adminNotes: "Verified via bank receipt",
    verifiedByAdminId: 2,
    verifiedAt: "2026-07-15T10:30:00Z",
    createdAt: "2026-07-15T09:00:00Z",
  },
  {
    transactionId: "TXN-E5F6G7H8",
    userId: 2,
    userFullName: "Jane Smith",
    userEmail: "jane.smith@example.edu",
    amount: 120.0,
    currency: "TRY",
    transactionType: "CLUB_MEMBERSHIP",
    relatedEntityId: "202",
    eventId: null,
    clubId: 1,
    status: "PENDING",
    paymentMethod: "MANUAL_TRANSFER",
    referenceCode: "REF-67890",
    adminNotes: null,
    verifiedByAdminId: null,
    verifiedAt: null,
    createdAt: "2026-07-16T11:15:00Z",
  },
  {
    transactionId: "TXN-I9J0K1L2",
    userId: 3,
    userFullName: "Alice Johnson",
    userEmail: "alice.johnson@example.edu",
    amount: 75.0,
    currency: "TRY",
    transactionType: "EVENT_TICKET",
    relatedEntityId: "103",
    eventId: 1,
    clubId: null,
    status: "REFUND_REQUESTED",
    paymentMethod: "MANUAL_TRANSFER",
    referenceCode: "REF-11223",
    adminNotes: "User requested refund",
    verifiedByAdminId: null,
    verifiedAt: null,
    createdAt: "2026-07-10T14:20:00Z",
  },
  {
    transactionId: "TXN-M3N4O5P6",
    userId: 4,
    userFullName: "Bob Williams",
    userEmail: "bob.williams@example.edu",
    amount: 50.0,
    currency: "TRY",
    transactionType: "EVENT_TICKET",
    relatedEntityId: "104",
    eventId: 1,
    clubId: null,
    status: "COMPLETED",
    paymentMethod: "MANUAL_TRANSFER",
    referenceCode: "REF-44556",
    adminNotes: "Verified",
    verifiedByAdminId: 2,
    verifiedAt: "2026-07-12T09:00:00Z",
    createdAt: "2026-07-11T16:45:00Z",
  },
  {
    transactionId: "TXN-Q7R8S9T0",
    userId: 5,
    userFullName: "Charlie Brown",
    userEmail: "charlie.brown@example.edu",
    amount: 120.0,
    currency: "TRY",
    transactionType: "CLUB_MEMBERSHIP",
    relatedEntityId: "205",
    eventId: null,
    clubId: 1,
    status: "COMPLETED",
    paymentMethod: "MANUAL_TRANSFER",
    referenceCode: "REF-77889",
    adminNotes: "Auto-verified mock",
    verifiedByAdminId: 2,
    verifiedAt: "2026-07-18T10:00:00Z",
    createdAt: "2026-07-17T15:30:00Z",
  }
];
